/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import { registerIconLibrary } from '@shoelace-style/shoelace/dist/utilities/icon-library.js';
import { setBasePath } from '@shoelace-style/shoelace/dist/utilities/base-path';
import 'react-indiana-drag-scroll/dist/style.css'
import '@shoelace-style/shoelace/dist/themes/light.css';
import 'react-toastify/dist/ReactToastify.css';

import logo from './logo.svg';


import Home from './components/Home';
import DesignerHome from './components/Designer/DesignerHome'
import ContentWriterHome from './components/ContentWriter/ContentWriterHome';
import AddCreative from './components/creatives/AddCreative';
import CreativewiseReport from './components/reports/CreativewiseReport';
// import Targeting from './components/campaign/Targeting';
import Login from './components/auth/Login';
import Users from './components/createUser/Users';
import Sales from './components/createUser/Sales';
import Finance from './components/createUser/Finance'
import RoUser from './components/ro/RoUser';
import CampaignDiscount from './components/discount/CampaignDiscount'
import Campaign from './components/campaign/Campaign';
import Dashboard from './components/dashboard/Dashboard';
import { ToastContainer } from 'react-toastify';
import Invoice from './components/invoice/Invoice';
import CampaignCategories from './components/campaign/CampaignCategories';
import PageNotFound from './components/PageNotFound';
import GuardedRoute from './Gaurdedroutes';
import LoggedIn from './LoggedIn';
import Start from './components/campaign/Start';
import Date from './components/campaign/Date';
import DesignerTab from './components/Designer/DesignerTab';
import CreativeSelection from './components/campaign/CreativeSelection';
// import Budget from './components/campaign/Budget';
import Target from './components/campaign/Target';
import PositionalPrice from './components/campaign/PositionalPrice';
import Reports from './components/reports/Reports';
import HiddenTarget from './components/campaign/Hidden_target';
import Queued from './components/networkads/Queued';
import Approved from './components/networkads/Approved';
import Blocked from './components/networkads/Blocked';
import NewsStream from './components/campaign/NewsStream';
import Birdview from './components/birdview/birdview';
import Contacts from './components/birdview/birdViewContact';
import Requests from './components/birdview/b2b_requests';
import AgencyData from './components/birdview/AgencyData';
import CompetitorData from './components/birdview/CompetitorData';
import AdsPrices from './components/reporterAds/AdsPrices';
import ReporterAds from './components/reporterAds/reporterAds';
import PosWiseImpress from "./components/campaign/PositionwiseImpressions"
import CompetitorReports from './components/birdview/competitor_reports';
import DefaultTab from './components/birdview/default';
import AppStats from './components/Stats/AppStats';
import LineItems from './components/lineItems/LineItems';
import Order from './components/Orders/Order';
import DiscountApproveCampaigns from './components/lineItems/DiscountApproveCampaigns';
import EncDiscountApprove from './components/lineItems/EncDiscountApprove';
import RestPassword from './components/auth/ResetPassword'
import AdUnit from './components/adUnits/AdUnit';
import DiscountRanges from './components/lineItems/DiscountRanges';
import GoogleForms from './components/adRequests/GoogleForm';
import AdRequests from './components/adRequests/AdRequests';
import lineItemsPlacements from './components/lineItemsPlacements/lineItemsPlacements'
import Brands from './components/brands/Brands';
import AccountManagement from './components/SalesPanel/AccountManagement';
import EffortAnalysis from './components/SalesPanel/EffortAnalysis';
import Impressions from './components/reports/PositionwiseImpressions';
import Pagerates from './components/birdview/pageRates';
import Editions from './components/birdview/newspaperEditions'
import TeamManagement from './components/SalesPanel/TeamManagement';
import './App.css';
// APP WIDE CUSTOM STYLES
import './Styles.scss';
import MarketSpendTracker from './components/SalesPanel/MarketSpendTracker';
import MarketShareAnalysis from './components/SalesPanel/MarketShareAnalysis';
import MyPerfomance from './components/SalesPanel/MyPerfomance';
import MyIncentives from './components/SalesPanel/MyIncentives';
import SalesDashBoard from './components/SalesPanel/SalesDashBoard';
import SalesContacts from './components/SalesPanel/SalesContacts';
import RevenueAnalysis from './components/SalesPanel/RevenueAnalysis';
import NewsPapers from './components/birdview/NewsPapers';
import FinanceDashboard from './components/financePanel/FinanceDashboard';
import FinanceReports from './components/financePanel/FinanceReports';
import BrandsReport from './components/SalesPanel/BrandsReport';
import PriceCalculator from './components/CardLists/PriceCalculator';
import SalesSlotBooking from './components/salesBooking/SalesSlotBooking';
import AddLineItem from './components/Orders/AddLineItem';
import SalesTrajectory from './components/SalesPanel/SalesTrajectory';
import MauDau from './components/Stats/MauDau';
import ApprovalSlotView from './components/salesBooking/ApprovalSlotView';
import SalesPriceCardList from './components/CardLists/SalesPriceCardList';
import SalesPriceCalculator from './components/CardLists/SalesPriceCalculator';
import BuildupSheet from './components/PlanningTabs/BuildupSheet';
import NationalPlanning from './components/PlanningTabs/NationalPlanning';
import PlanningReports from './components/PlanningTabs/PlanningReports';
import EffortAnalysisDashboard from './components/SalesPanel/EffortAnalysisDashboard';
import Help from './components/SalesPanel/Help';
import HourlyStats from './components/hourlyStats/HourlyStats';
import MonthlyReports from './components/PlanningTabs/MonthlyReports';
import CompetitorDataAI from './components/birdview/CompetitorDataAI';
import CSTDayCalendar from './components/salesBooking/CSTDayCalendar';
import AlphaBirdview from './components/birdview/AlphaBirdview';
import BirdViewReject from './components/birdview/BirdViewReject';
import VersionChecker from './shared/VersionNotifier';
import DownloadCreativePreviews from './creativePreviews/DownloadCreativePreviews';
import SalesReports from './components/PlanningTabs/SalesReports';
import Inventory from './components/inventory/Inventory';
import AdResponses from './components/inventory/AdResponses';
import CampaignInfo from './components/campaign/CampaignInfo';
import AdPartners from './components/NetworkPanel/AdPartners'
import SalesWiseInteractions from './components/Stats/SalesWiseInteractions';
import SalesCoverage from './components/SalesPanel/SalesCoverage';
import AdCodeAlerts from './components/inventory/AdCodeAlerts';
import AlphaPositionalPrice from './components/campaign/AlphaPositionalPrice';
import ClassifiedPositionalPrice from './components/campaign/ClassifiedPositionalPrice';
import UnifiedPositionalPrice from './components/campaign/UnifiedPositionalPrice';
import NewspaperViewerAlpha from './components/birdview/NewspaperViewer/NewspaperViewer';
import NewspaperViewer from './components/birdview/NewspaperViewer';
import WebViewUpload from './components/creatives/WebView/WebViewUpload';
import NetworkReportHourly from './components/adRequests/NetworkReportHourly';
import CustomReports from './components/reports/custom_reports/CustomReports';
import RedisObjects from './components/Redis/RedisObjects';
import AlphaCompetitorReports from './components/birdview/AlphaCompetitor_reports';
import InboundVernacular from './components/SalesPanel/InboundVernacular';
import BrandLocations from './components/brands/BrandLocations';
import EenaduPageRates from './components/birdview/EenaduPageRates';
import PhionexReports from './components/PhionexReports/PhionexReports';
import Zones from './components/Zones/Zones';
import AdCodeStats from './components/adUnits/AdCodeStats';
import CategoryUpdater from './components/lineItems/CategoryUpdater';

setBasePath('https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.3.0/dist/');


function App() {

  // BOX ICONS IMPORT
  registerIconLibrary('boxicons', {
    resolver: name => {
      let folder = 'regular';
      if (name.substring(0, 4) === 'bxs-') folder = 'solid';
      if (name.substring(0, 4) === 'bxl-') folder = 'logos';
      return `https://cdn.jsdelivr.net/npm/boxicons@2.0.5/svg/${folder}/${name}.svg`;
    },
    mutator: svg => svg.setAttribute('fill', 'currentColor')
  });


  // LUCIDE ICONS IMPORT
  registerIconLibrary('lucide', {
    resolver: name => `https://cdn.jsdelivr.net/npm/lucide-static@0.16.29/icons/${name}.svg`
  });

  registerIconLibrary('material', {
    resolver: name => {
      const match = name.match(/^(.*?)(_(round|sharp))?$/);
      return `https://cdn.jsdelivr.net/npm/@material-icons/svg@1.0.5/svg/${match[1]}/${match[3] || 'outline'}.svg`;
    },
    mutator: svg => svg.setAttribute('fill', 'currentColor')
  });

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />}></Route>
          <Route path="/home" element={<GuardedRoute Component={Home} />}>
            <Route path='dashboard' element={<GuardedRoute Component={Dashboard} />} />
            <Route path='creatives' element={<GuardedRoute Component={AddCreative} />} />
            <Route path='lineitems' element={<GuardedRoute Component={LineItems}/>}/>
            <Route path='lineitems/created' element={<GuardedRoute Component={LineItems}/>}/>
            <Route path='lineitems/running' element={<GuardedRoute Component={LineItems}/>}/>
            <Route path='lineitems/paused' element={<GuardedRoute Component={LineItems}/>}/>
            <Route path='lineitems/completed' element={<GuardedRoute Component={LineItems}/>}/>
            <Route path='lineitems/scheduled' element={<GuardedRoute Component={LineItems}/>}/>
            <Route path='lineitems/approved' element={<GuardedRoute Component={LineItems}/>}/>
            <Route path='lineitems/internal' element={<GuardedRoute Component={LineItems}/>}/>

            <Route path='lineitems/discountApprove' element={<GuardedRoute Component={DiscountApproveCampaigns}/>}/>
            <Route path='discountranges' element={<GuardedRoute Component={DiscountRanges} />}/>
            <Route path='campaign' element={<GuardedRoute Component={Campaign} />} />
            <Route path='campaign/created' element={<GuardedRoute Component={Campaign} />} />
            <Route path='campaign/running' element={<GuardedRoute Component={Campaign} />} />
            <Route path='campaign/paused' element={<GuardedRoute Component={Campaign} />} />
            <Route path='campaign/completed' element={<GuardedRoute Component={Campaign} />} />
            <Route path='campaign/scheduled' element={<GuardedRoute Component={Campaign} />} />
            <Route path='creative-reports' element={<GuardedRoute Component={Reports} />} />
            <Route path='campaign-categories' element={<GuardedRoute Component={CampaignCategories} />} />
            {/* <Route path='targeting' element={<GuardedRoute Component={Users} />} /> */}
            <Route path='users' element={<GuardedRoute Component={Users} />} />
            <Route path='ro' element={<GuardedRoute Component={RoUser} />} />
            {/* <Route path='invoice' element={<GuardedRoute Component={Invoice} />} /> */}
            <Route path='campaign/start' element={<GuardedRoute Component={Start} />} />
            {/* <Route path='campaign/budget' element={<GuardedRoute Component={Budget} />} /> */}
            <Route path='campaign/creatselect' element={<GuardedRoute Component={CreativeSelection} />} />
            <Route path='campaign/date' element={<GuardedRoute Component={Date} />} />
            <Route path='campaign/target' element={<GuardedRoute Component={Target} />} />
            <Route path='location_prices' element={<GuardedRoute Component={PositionalPrice} />} />
            <Route path='alpha_location_prices' element={<GuardedRoute Component={AlphaPositionalPrice} />} />
            <Route path='classified_location_prices' element={<GuardedRoute Component={ClassifiedPositionalPrice} />} />
            <Route path='unified_location_prices' element={<GuardedRoute Component={UnifiedPositionalPrice} />} />
            <Route path='campaign_discount' element={<GuardedRoute Component={CampaignDiscount} />} />
            <Route path='campaign/hiddentarget' element={<GuardedRoute Component={HiddenTarget} />} />

            <Route path='networkads/queued' element={<GuardedRoute Component={Queued} />} />
            <Route path='networkads/approved' element={<GuardedRoute Component={Approved} />} />
            <Route path='networkads/blocked' element={<GuardedRoute Component={Blocked} />} />
            <Route path='newstream' element={<GuardedRoute Component={NewsStream} />} />

            {/* <Route path='birdview/appinfo' element={<GuardedRoute Component={Birdview} />} /> */}
            <Route path='competitor_data/get' element={<GuardedRoute Component={DefaultTab} />} />
            <Route path='b2b_contacts/get' element={<GuardedRoute Component={Contacts} />} />
            <Route path='b2b_requests/get' element={<GuardedRoute Component={Requests} />} />
            <Route path='agency_data/get' element={<GuardedRoute Component={AgencyData} />} />
            {/* <Route path='ads_price_location/getAdsAmounts' element={<GuardedRoute Component={AdsPrices} />} /> */}
            <Route path='ads_price_location/getAdsAmounts' element={<GuardedRoute Component={ReporterAds} />} />
            <Route path='positionwise-impressions' element={<GuardedRoute Component={PosWiseImpress} />} />
            <Route path='competitor_reports/get' element={<GuardedRoute Component={CompetitorReports} />} />
            <Route path='alphacompetitor_reports/get' element={<GuardedRoute Component={AlphaCompetitorReports}/>}/>
            <Route path='app-stats' element ={<GuardedRoute Component={AppStats} />}/>
            <Route path='order' element={<GuardedRoute Component = {Order} />}>
            </Route>
            <Route path="order/:id" element={<GuardedRoute Component={AddLineItem} />} />
            <Route path='order/running' element={<GuardedRoute Component={Order} />} />
            <Route path='order/paused' element={<GuardedRoute Component={Order} />} />
            <Route path='order/completed' element={<GuardedRoute Component={Order} />} />
            <Route path='order/internal' element={<GuardedRoute Component={Order} />} />
            
            <Route path='adunit' element={<GuardedRoute Component={AdUnit} />} />
            <Route path="discount/:id" element={<GuardedRoute Component={EncDiscountApprove} />} />
            <Route path='adrequest/getAdRequests' element={<GuardedRoute Component={AdRequests} />} />
            <Route path='placements' element={<GuardedRoute Component={lineItemsPlacements} />} />
            <Route path='brands' element={<GuardedRoute Component ={Brands} />} />
            <Route path='buildup' element={<GuardedRoute Component={BuildupSheet} />} />
            <Route path='sales/account' element={<GuardedRoute Component={AccountManagement}/>} />
            <Route path='sales/effortdashboard' element={<GuardedRoute Component={EffortAnalysisDashboard}/>} />
            <Route path='sales/effort' element={<GuardedRoute Component={EffortAnalysis}/>} />
            <Route path='sales/teamManagement' element={<GuardedRoute Component={TeamManagement}/>} />
            <Route path='sales/market-tracker' element={<GuardedRoute Component={MarketSpendTracker} />} />
            <Route path='sales/market-share' element={<GuardedRoute Component={MarketShareAnalysis} />} />
            <Route path='sales/coverage' element={<GuardedRoute Component={SalesCoverage} />} />
            <Route path='sales/perfomance' element={<GuardedRoute Component={MyPerfomance} />} />
            <Route path='sales/incentives' element={<GuardedRoute Component={MyIncentives} />} />
            <Route path='sales/dashboard' element={<GuardedRoute Component={SalesDashBoard} />} />
            <Route path='sales/contacts' element={<GuardedRoute Component={SalesContacts} />} />
            <Route path='sales/revenue' element={<GuardedRoute Component={RevenueAnalysis} />} />
            <Route path='reports/position_impressions' element={<GuardedRoute Component={Impressions} />} />
            <Route path='page_rates' element={<GuardedRoute Component={Pagerates} />} />
            <Route path='newspaper_data' element={<GuardedRoute Component={NewsPapers} />} />
            <Route path='editions' element={<GuardedRoute Component={Editions} />} />
            <Route path='finance/dashboard' element={<GuardedRoute Component={FinanceDashboard} />} />
            <Route path='finance/reports' element={<GuardedRoute Component={FinanceReports} />} />
            <Route path='brandsreport' element={<GuardedRoute Component={BrandsReport} />} />
            <Route path='pricecalculator' element={<GuardedRoute Component={PriceCalculator} />} />
            <Route path='slotbooking'element={<GuardedRoute Component={SalesSlotBooking} />} />
            <Route path='slotbooking/:id'element={<GuardedRoute Component={ApprovalSlotView} />} />
            <Route path='maudau' element={<GuardedRoute Component={MauDau} />} />
            <Route path='sales_location_prices' element={<GuardedRoute Component={SalesPriceCardList} />} />
            <Route path='salespricecalculator' element={<GuardedRoute Component={SalesPriceCalculator} />} />
            <Route path='brandreports' element={<GuardedRoute Component={PlanningReports} />} />
            <Route path='help' element={<GuardedRoute Component={Help} />} />
            <Route path='hourlystats' element={<GuardedRoute Component={HourlyStats} />} />
            <Route path='monthlyreview' element={<GuardedRoute Component={MonthlyReports} />} />
            <Route path='birdviewai' element={<GuardedRoute Component={CompetitorDataAI} />} />
            <Route path='daycalendar' element={<GuardedRoute Component={CSTDayCalendar} />} />
            <Route path="birdview-alpha" element={<GuardedRoute Component={AlphaBirdview} />} />
            <Route path="birdview-reject" element={<GuardedRoute Component={BirdViewReject} />} />
            <Route path="campaign_info" element={<GuardedRoute Component={CampaignInfo}/>}/>
            <Route path="download_creative_previews" element={<GuardedRoute Component={DownloadCreativePreviews} />} />
            <Route path='saleswise_interactions' element={<GuardedRoute Component={SalesWiseInteractions} />} />
            <Route path='salesreports' element={<GuardedRoute Component={SalesReports} />} />
            <Route path='inventory' element={<GuardedRoute Component={Inventory} />} />
            <Route path='adresponses' element={<AdResponses Component={AdResponses}/>} />
            <Route path='adpartners' element={<GuardedRoute Component={AdPartners} />} />
            <Route path='designer' element={<GuardedRoute Component={DesignerHome} />} />
            <Route path='alpha-designer' element={<GuardedRoute Component={DesignerTab} />} />
            <Route path='adalerts' element={<GuardedRoute Component={AdCodeAlerts} />}  />
            <Route path='newspaper-viewer-alpha' element={<GuardedRoute Component={NewspaperViewerAlpha} />} />
            <Route path='adcode_hourly' element={<GuardedRoute Component={NetworkReportHourly} />} />
            <Route path='newspaper-viewer' element={<GuardedRoute Component={NewspaperViewer} />} />
            <Route path='creatives/webviewupload' element={<GuardedRoute Component={WebViewUpload} />}  />
            <Route path='custom_reports' element={<GuardedRoute Component={CustomReports} />} />
            <Route path='content_writer' element={<GuardedRoute Component={ContentWriterHome}/>} />
            <Route path='redis-objects' element={<GuardedRoute Component={RedisObjects}/>} />
            <Route path='inbound_vernacular' element={<GuardedRoute Component={InboundVernacular}/>} />
            <Route path='brandlocations' element={<GuardedRoute Component={BrandLocations}/>}/>
            <Route path='eenadu/page_rates' element={<GuardedRoute Component={EenaduPageRates} />} />
            <Route path="phionex_reports" element={<GuardedRoute Component={PhionexReports}/>}/>
            <Route path='zones' element={<GuardedRoute Component={Zones} />} />
            <Route path = 'ad_code_stats' element={<GuardedRoute Component={AdCodeStats} />} />
            <Route path ='category-update' element={<GuardedRoute Component={CategoryUpdater} />} />
          </Route>
          <Route path='/resetPswd/:id' element={<RestPassword />} />
          <Route path='*' element={<PageNotFound />} />
          <Route path='/adrequest/fill_adReqForm' element={<GoogleForms />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer position="top-right" autoClose={5000} />
      <VersionChecker />
    </>
  );
}

export default App;